export default "__VITE_ASSET__CCIrkbER__"